export const EXTRA_FAST = 100;
export const FAST = 150;
export const MEDIUM = 200;
export const SLOW = 250;
export const EXTRA_SLOW = 300;
export const EXTRA_EXTRA_SLOW = 500;
